export let ErrorActionTypes;

(function (ErrorActionTypes) {
  ErrorActionTypes["SetError"] = "[Error] Set Error";
  ErrorActionTypes["ClearError"] = "[Error] Clear Error";
})(ErrorActionTypes || (ErrorActionTypes = {}));